import { ISearchPrams } from 'models/common'
import API from './axiosClient/axiosClient'
import { IDashboardSettingReq, ISidePanelReq } from 'models/dashboard'
import { r } from 'utils/common'
import { IDashboardLayoutReq } from 'models/dashboardSetting'

const APIs = {
  DASHBOARD_SETTING: '/api/v1/dashboard-settings',
  DASHBOARD_SETTING_DETAIL: '/api/v1/dashboard-settings/:id',
  DASHBOARD_LIST: '/api/v1/dashboards/charts',
  DASHBOARD_RESET: '/api/v1/dashboard-settings/reset',
  DASHBOARD_RESTORE: '/api/v1/dashboard-settings/restore',
  DASHBOARD_REVERT_INIT: '/api/v1/dashboard-settings/revert-init',
  DASHBOARD_DELETE_CHART: '/api/v1/dashboard-settings/chart/:id',
  DASHBOARD_DELETE_CHART_SETTING: '/api/v1/dashboard-settings/chart/:id',
  DASHBOARD_LAYOUT: '/api/v1/dashboard-layouts/:id',
  DASHBOARD_LAYOUT_CREATE: '/api/v1/dashboard-layouts',
  DASHBOARD_SIDE_PANEL: '/api/v1/dashboards/side-panel'
}

export const getDashboardSetting = async (params: Partial<ISearchPrams>) => {
  if (params?.clientId) {
    return API.get(APIs.DASHBOARD_SETTING, { ...params, clientId: +params.clientId })
  }
}

export const createNewDashboardSetting = async (value: any) => {
  const data = value.data?.[0]
  const req = {
    ...data,
    kpiIds: data?.kpiIds?.flat(),
    departmentIds: data?.departmentIds?.flat(),
    staffIds: data?.staffIds?.flat(),
    metricTypes: data?.metricTypes?.flat()
  }

  return API.post(APIs.DASHBOARD_SETTING, {
    dashboard: [req]
  })
}

export const updateDashboardSetting = async (value: any) => {
  const data = value.data?.[0]
  const req = {
    ...data,
    kpiIds: data?.kpiIds?.flat(),
    departmentIds: data?.departmentIds?.flat(),
    staffIds: data?.staffIds?.flat() || [],
    metricTypes: data?.metricTypes?.flat()
  }
  return API.patch(APIs.DASHBOARD_SETTING, {
    dashboard: [req]
  })
}

export const getDashboardList = async (values: IDashboardSettingReq) => {
  return API.post(APIs.DASHBOARD_LIST, values)
}

export const resetDashboard = async (clientId?: string) => {
  if (clientId) {
    return API.post(APIs.DASHBOARD_RESET, {
      clientId: +clientId
    })
  }
}

export const restoreDashboard = async (clientId?: string) => {
  if (clientId) {
    return API.post(APIs.DASHBOARD_RESTORE, {
      clientId: +clientId
    })
  }
}
export const revertInitDashboard = async (clientId?: string) => {
  if (clientId) {
    return API.post(APIs.DASHBOARD_REVERT_INIT, {
      clientId: +clientId
    })
  }
}

export const deleteDashboardChartItem = async (id: number) => {
  return API.delete(r(APIs.DASHBOARD_DELETE_CHART, { id }))
}

export const deleteDashboardSettingItem = async (id: number) => {
  return API.delete(r(APIs.DASHBOARD_DELETE_CHART_SETTING, { id }))
}

export const getDashboardSettingDetail = async (id: number) => {
  return API.get(r(APIs.DASHBOARD_SETTING_DETAIL, { id }))
}

export const getDashboardLayouts = async (id: number) => {
  return API.get(r(APIs.DASHBOARD_LAYOUT, { id }))
}

export const createDashboardLayouts = async (value: IDashboardLayoutReq) => {
  return API.post(APIs.DASHBOARD_LAYOUT_CREATE, value)
}

export const getDashboardSidePanel = async (params: ISidePanelReq) => {
  return API.get(APIs.DASHBOARD_SIDE_PANEL, { ...params })
}
